export default {
    // 百度地图key
    B_KEY: 'YthGcNXzpz9NmKiT56VOHk98ofeGGt7k',
    // 百度地图api接口域名
    B_DOMAIN: 'https://api.map.baidu.com',
    // 精准度
    ACCURACY: 100
}